export * from './lib/models/avatar.model';
export * from './lib/types/avatar-config.type';
export * from './lib/avatar.module';
